<div class="card card-profile">
  <div class="header">
    <div class="d-flex align-items-center gap-12">
      <i class="icon ic-tags-20"></i>
      <h3>Tags</h3>
    </div>

    <div
      *appHasRole="['Admin', 'Manager', 'Preparer']"
      #selectTagsDropdown="ngbDropdown"
      ngbDropdown
      [placement]="dropdownPlacement"
    >
      <button
        ngbDropdownToggle
        title="Customize"
        class="btn btn-secondary btn-icon d-flex align-items-center justify-content-center"
        [disabled]="disableControls"
      >
        <i class="icon ic-settings-20"></i>
      </button>

      <app-select-tags-dropdown
        ngbDropdownMenu
        [entityProfile]="entityProfile"
        [tags]="entityProfile.tags"
        [disabled]="disableControls"
        (assignTag)="assignTag($event)"
        (addNewTag)="addNewTag()"
      ></app-select-tags-dropdown>
    </div>
  </div>

  <div class="customize-tags-tip">
    Click the gear icon to manage tags
  </div>

  <div class="tags-wrapper">
    @if (systemTags.length || actualTagsSignal().length) {
      <ul class="tags-list">
        @for (tag of systemTags; track tag) {
          <li class="tag-item">
            <app-tag [tag]="tag"></app-tag>
          </li>
        }

        @for (tag of actualTagsSignal(); track tag) {
          <li class="tag-item">
            <app-tag [tag]="tag"></app-tag>
          </li>
        }
      </ul>
    } @else {
      <div class="no-data">{{ noTagsAssignedMessage }}</div>
    }
  </div>
</div>
